import styled from 'styled-components';
import { ColumnDiv, Div } from 'styles/elements/div';
import Input from 'styles/elements/input';
import { SecondaryButton } from 'styles/elements/buttons/primaryCare';
import { Error } from 'styles/blocks/error';
import { OkCircle } from 'assets/primaryCare/icons';
import media from 'styles/media';

const Postcode = styled(ColumnDiv)``;

const InputContainer = styled(Div)`
  align-items: center;
  flex: 1 1 auto;
`;

const PostcodeInput = styled(Input)`
  padding: 0 1em;
  width: 30%;
  ${media.smallAndBelow`
    width: 80%;
  `};
`;

const FindAddressButton = styled(SecondaryButton)`
  padding: 5px 1em;
  margin: 1em 0 1em;
`;

const OkIcon = styled(OkCircle)`
  margin: 0 10px 0 15px;
  ${media.IE9 ? `
    display: inline-block;
  ` : ''};
`;

const Text = styled.p`
  margin-bottom: 0.5em;
`;

const PostcodeError = styled(Error)`
  margin-bottom: 10px;
  margin-top: 0;
`;

Postcode.InputContainer = InputContainer;
Postcode.Input = PostcodeInput;
Postcode.FindAddressButton = FindAddressButton;
Postcode.OkIcon = OkIcon;
Postcode.Text = Text;
Postcode.Error = PostcodeError;

export default Postcode;
